import React from 'react';
import { useNavigate } from 'react-router-dom';

const Help = () => {
  const navigate = useNavigate();

  const contactOptions = [
    {
      icon: (
        <svg className='md:h-[30px] md:w-[30px]' xmlns="http://www.w3.org/2000/svg" width="24"  height="24"  viewBox="0 0 24 24" fill="none">
          <g clip-path="url(#clip0_3005_65)">
            <path d="M5 4H9L11 9L8.5 10.5C9.57096 12.6715 11.3285 14.429 13.5 15.5L15 13L20 15V19C20 19.5304 19.7893 20.0391 19.4142 20.4142C19.0391 20.7893 18.5304 21 18 21C14.0993 20.763 10.4202 19.1065 7.65683 16.3432C4.8935 13.5798 3.23705 9.90074 3 6C3 5.46957 3.21071 4.96086 3.58579 4.58579C3.96086 4.21071 4.46957 4 5 4Z" stroke="#78736A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </g>
          <defs>
            <clipPath id="clip0_3005_65">
              <rect width="24" height="24" fill="white"/>
            </clipPath>
          </defs>
        </svg>
      ),
      title: "Call Us",
      description: "You can reach out to us Mon - Sat between 10:00-06:30 Hrs.",
      action: () => window.open('tel:+912265074478')
    },
    {
      icon: (
        <svg className='md:h-[30px] md:w-[30px]' xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <g clip-path="url(#clip0_3005_79)">
            <path d="M3 21L4.65 17.2C3.38766 15.4081 2.82267 13.217 3.06104 11.0381C3.29942 8.85918 4.32479 6.84214 5.94471 5.36552C7.56463 3.8889 9.66775 3.05421 11.8594 3.0181C14.051 2.98198 16.1805 3.74693 17.8482 5.16937C19.5159 6.59182 20.6071 8.57398 20.9172 10.7439C21.2272 12.9138 20.7347 15.1222 19.5321 16.9548C18.3295 18.7873 16.4994 20.118 14.3854 20.6971C12.2713 21.2762 10.0186 21.0639 8.05 20.1L3 21Z" stroke="#78736A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M9 10C9 10.1326 9.05268 10.2598 9.14645 10.3536C9.24021 10.4473 9.36739 10.5 9.5 10.5C9.63261 10.5 9.75979 10.4473 9.85355 10.3536C9.94732 10.2598 10 10.1326 10 10V9C10 8.86739 9.94732 8.74021 9.85355 8.64645C9.75979 8.55268 9.63261 8.5 9.5 8.5C9.36739 8.5 9.24021 8.55268 9.14645 8.64645C9.05268 8.74021 9 8.86739 9 9V10ZM9 10C9 11.3261 9.52678 12.5979 10.4645 13.5355C11.4021 14.4732 12.6739 15 14 15M14 15H15C15.1326 15 15.2598 14.9473 15.3536 14.8536C15.4473 14.7598 15.5 14.6326 15.5 14.5C15.5 14.3674 15.4473 14.2402 15.3536 14.1464C15.2598 14.0527 15.1326 14 15 14H14C13.8674 14 13.7402 14.0527 13.6464 14.1464C13.5527 14.2402 13.5 14.3674 13.5 14.5C13.5 14.6326 13.5527 14.7598 13.6464 14.8536C13.7402 14.9473 13.8674 15 14 15Z" stroke="#78736A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </g>
          <defs>
            <clipPath id="clip0_3005_79">
              <rect width="24" height="24" fill="white"/>
            </clipPath>
          </defs>
        </svg>
      ),
      title: "WhatsApp",
      description: "Chat with us our support team—no bots, just helpful humans!",
      action: () => window.open('https://wa.me/918160862350')
    },
    {
      icon: (
        <svg className='md:h-[30px] md:w-[30px]' xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <g clip-path="url(#clip0_3005_94)">
            <path d="M12 18H5C4.46957 18 3.96086 17.7893 3.58579 17.4142C3.21071 17.0391 3 16.5304 3 16V6C3 5.46957 3.21071 4.96086 3.58579 4.58579C3.96086 4.21071 4.46957 4 5 4H19C19.5304 4 20.0391 4.21071 20.4142 4.58579C20.7893 4.96086 21 5.46957 21 6V13.5" stroke="#78736A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M3 6L12 12L21 6" stroke="#78736A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M15 18H21" stroke="#78736A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M18 15L21 18L18 21" stroke="#78736A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </g>
          <defs>
            <clipPath id="clip0_3005_94">
              <rect width="24" height="24" fill="white"/>
            </clipPath>
          </defs>
        </svg>
      ),
      title: "Write to us",
      description: "Chat with us our support team—no bots, just helpful humans!",
      action: () => window.open('mailto:help@bookforpaws.com')
    }
  ];

  return (
    <div className="min-h-screen bg-[#FAF7F2] md:px-[120px] md:py-[60px]">
      

      {/* Page Title with Back Button */}
      <div className="bg-[#FAF7F2] p-[16px] gap-[16px] flex items-center ">
        <button 
          onClick={() => navigate(-1)}
          className="hover:bg-gray-100 rounded-full"
        >
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <g clip-path="url(#clip0_3005_53)">
            <path d="M5 12H19" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M5 12L11 18" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M5 12L11 6" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </g>
          <defs>
            <clipPath id="clip0_3005_53">
              <rect width="24" height="24" fill="white"/>
            </clipPath>
          </defs>
        </svg>
        </button>
        <h1 className="text-[20px] font-medium text-black tracking-[-1px]">Customer Support</h1>
      </div>

      {/* Main Content */}
      <div className="p-[20px] flex flex-col md:flex-row gap-[8px] md:gap-[24px]">
        {/* Contact Options */}
        {contactOptions.map((option, index) => (
          <div
            key={index}
            onClick={option.action}
            className="bg-white rounded-[16px] p-[24px] flex items-center justify-between cursor-pointer hover:bg-gray-50 transition-colors shadow-sm"
          >
            <div className="flex flex-col items-center  gap-[24px] ">
              <div className="w-full flex items-center md:items-start justify-between text-gray-600">
                <div className='flex items-center md:flex-col md:items-start gap-[12px]'>

                {option.icon}
                <h3 className="font-medium text-black text-[20px] md:text-[24px] tracking-[-1px]">{option.title}</h3>
                </div>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <g clip-path="url(#clip0_3005_69)">
                    <path d="M19 12H5" stroke="#FF5E4C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M19 12L13 18" stroke="#FF5E4C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M19 12L13 6" stroke="#FF5E4C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </g>
                  <defs>
                    <clipPath id="clip0_3005_69">
                      <rect width="24" height="24" fill="white" transform="matrix(-1 0 0 1 24 0)"/>
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <div>
                <p className="text-[14px] text-[#84807A] leading-none font-medium tracking-[-0.7px]">{option.description}</p>
              </div>
            </div>
          </div>
        ))}

      </div>
       {/* Address Section */}
       <div className="p-[20px]">
          <div className="flex items-center gap-[4px] mb-[8px]">
            <h2 className="font-medium text-[18px] text-black tracking-[-0.37px]">Address</h2>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <g clip-path="url(#clip0_3005_111)">
                <path d="M15 3C15.7956 3 16.5587 3.31607 17.1213 3.87868C17.6839 4.44129 18 5.20435 18 6C18.4933 5.99989 18.9791 6.12146 19.4142 6.35392C19.8494 6.58638 20.2205 6.92256 20.4946 7.33269C20.7688 7.74282 20.9376 8.21424 20.9861 8.70519C21.0346 9.19614 20.9613 9.69147 20.7726 10.1473C20.5839 10.6031 20.2857 11.0054 19.9045 11.3185C19.5232 11.6316 19.0706 11.8458 18.5868 11.9422C18.1029 12.0386 17.6028 12.0142 17.1307 11.8711C16.6585 11.728 16.229 11.4707 15.88 11.122L11.122 15.88C11.4654 16.2237 11.7202 16.6456 11.8645 17.1095C12.0087 17.5734 12.0382 18.0654 11.9503 18.5433C11.8624 19.0211 11.6597 19.4704 11.3598 19.8526C11.0599 20.2347 10.6716 20.5384 10.2284 20.7373C9.78516 20.9363 9.30025 21.0246 8.81534 20.9948C8.33043 20.9649 7.86003 20.8177 7.44458 20.5658C7.02913 20.314 6.68106 19.965 6.4303 19.5489C6.17954 19.1328 6.03359 18.662 6.005 18.177V18H5.829C5.34383 17.9716 4.87284 17.8257 4.45653 17.5749C4.04023 17.3242 3.69108 16.976 3.43913 16.5604C3.18717 16.1448 3.03996 15.6743 3.01014 15.1892C2.98033 14.7041 3.06881 14.219 3.26798 13.7757C3.46715 13.3324 3.77103 12.9441 4.15349 12.6442C4.53596 12.3444 4.98554 12.1419 5.46357 12.0543C5.94161 11.9667 6.43377 11.9965 6.89773 12.1412C7.36168 12.2859 7.78354 12.5412 8.127 12.885L12.885 8.127C12.4653 7.70756 12.1794 7.17307 12.0635 6.59114C11.9475 6.0092 12.0068 5.40595 12.2337 4.85769C12.4606 4.30943 12.845 3.84077 13.3383 3.51099C13.8316 3.18121 14.4116 3.00513 15.005 3.005L15 3Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
              </g>
              <defs>
                <clipPath id="clip0_3005_111">
                  <rect width="24" height="24" fill="white"/>
                </clipPath>
              </defs>
            </svg>
          </div>
          <div className="text-[12px] text-[#8c8c8c] leading-[1.35] space-y-[6px]">
            <p className="font-medium text-[#6b6b6b]">JOEY AND CHANDLER TECH VENTURES LLP</p>
            <p>
              Mumbai Office : WEWORK, NESCO, Building 4, North Wing, NESCO IT Park, Western Express Hwy, NESCO, Goregaon East, Mumbai, Maharashtra 400063
            </p>
            <p>
              Regd Office : 5, Colonel Corner, Airport Road, Gandhi Nagar (Bhopal), Bhopal- 462036, Madhya Pradesh, India
            </p>
            <p>Working Hours - 11:00 AM - 8:00 PM</p>
          </div>
        </div>
    </div>
  );
};

export default Help; 